import { render, staticRenderFns } from "./GiftImage.vue?vue&type=template&id=0d29c1e3&"
import script from "./GiftImage.vue?vue&type=script&lang=js&"
export * from "./GiftImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports